<div
  class="chat-messages"
  #chatWrapper
  role="log"
  aria-live="polite"
  [attr.aria-label]="logAriaLabel()"
  aria-relevant="additions text"
  aria-atomic="false"
  [attr.aria-busy]="messagePrependLoading() || messageAppendLoading()"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  [infiniteScrollUpDistance]="-9"
  (scrolled)="scrolled.emit()"
  (scrolledUp)="scrolledUp.emit()"
  (scroll)="onScroll($event)"
  [scrollWindow]="false">
  <div
    class="bottom"
    inViewport
    [inViewportOptions]="{ threshold: [0], rootMargin: '100px' }"
    (inViewportAction)="lastMessageVisible($event)"></div>

  @let messageErrors = errors();
  @if (messageErrors) {
    @for (error of messageErrors; track error.id) {
      <orbit-message
        [message]="error.message ?? error.code | translate"
        [severity]="'error'"
        [addonButtonIcon]="refreshIcon"
        (addonButtonClick)="refreshMessages.emit()" />
    }
  }

  @if (otherTypingParticipants()) {
    @for (participant of otherTypingParticipants(); track participant.id) {
      <shared-chat-bubble
        [messageKind]="chatBubbleKind.IsTyping"
        [messageId]="'isTyping'"
        [conversationAppType]="conversationAppType()"
        [showCreator]="participant.displayName ?? undefined"
        [ariaLabel]="(participant.displayName ?? 'Someone') + ' is typing'"
        [isTyping]="true" />
    }
  }

  @if (messagePrependLoading()) {
    <orbit-fa-icon class="loading-icon" [iconName]="spinnerIcon" animation="spin" iconSize="2x" />
  }

  @for (message of messages(); track message.id; let i = $index) {
    <shared-chat-bubble
      data-testid="message-bubble"
      [attr.data-message-id-value]="message.id"
      [attr.data-message-source-id-value]="message.sourceId"
      [attr.data-message-sequence-value]="message.sequence"
      inViewport
      [asset]="message.asset"
      [creatorParticipantId]="message.participantId"
      [creatorKind]="
        (conversationParticipants() ?? [] | findBy: 'id' : message.participantId)?.kind ?? undefined
      "
      [formattedAddress]="message.formattedAddress"
      [isUnread]="unreadMessages() > 0 && i <= unreadMessages() - 1"
      [inViewportOptions]="{ threshold: [1.0], rootMargin: '0px' }"
      [lastSeenMessageSequence]="lastSeenMessageSequence()"
      [mapCenterCoordinates]="{
        latitude: message.location?.latitude ?? 0,
        longitude: message.location?.longitude ?? 0,
        accuracy: message.location?.accuracy,
      }"
      [messageId]="message.id"
      [messageKind]="message.kind"
      [messageSequence]="message.sequence"
      [messageSourceId]="message.sourceId"
      [messageText]="message.text"
      [messageIdsWithError]="messageIdsWithError()"
      [showCreator]="
        (conversationParticipants() ?? [] | findBy: 'id' : message.participantId)?.displayName ??
        undefined
      "
      [conversationAppType]="conversationAppType()"
      [ariaLabel]="getMessageLabel(message)"
      [sharedUserDisplayName]="sharedUserDisplayName()"
      [time]="message.createdAt"
      [userParticipantId]="participant()?.id"
      [windowService]="windowService()"
      (assetClick)="assetClick.emit($event)"
      (buttonClick)="buttonClick.emit($event)"
      (inViewportAction)="toggleMessageVisibility($event, message)"
      (resendMessage)="resendMessage.emit(message.id)" />
  }

  @if (messageAppendLoading()) {
    <orbit-fa-icon class="loading-icon" [iconName]="spinnerIcon" animation="spin" iconSize="2x" />
  }
</div>
@if (showUnreadMessages()) {
  <button
    type="button"
    class="button-reset new-message-indicator"
    tabindex="0"
    [attr.aria-label]="newMessageIndicatorLabel()"
    (click)="scrollToBottom()"
    (keydown)="onScrollToBottomKeyDown($event)">
    <orbit-fa-icon class="simple-icon" [iconName]="arrowIcon" />
    {{ unreadMessages() }}
  </button>
}
